
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignArrowRight as ObiSignArrowRightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sign-arrow-right.js';
 
 
 

 
 export const ObiSignArrowRight = createComponent({
   react: React,
   tagName: 'obi-sign-arrow-right',
   elementClass: ObiSignArrowRightElement,
   events: {
     
   }
  });
 
 